module.exports = __webpack_public_path__ + "img/little5.89a2909d.webp";